import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/app/common/views/Home.vue";
import LoginPage from "@/app/common/views/LoginPage.vue";
import RegisterPage from "@/app/common/views/RegisterPage.vue";
import EmailVerification from "@/app/common/views/EmailVerification.vue";
import NumberVerification from "@/app/common/views/NumberVerification.vue";
import RecoverPassword from "@/app/common/views/RecoverPassword.vue";
import PasswordRecovery from "@/app/common/views/PasswordRecovery.vue";
import Profilo from "@/app/common/views/Profilo.vue";
import Disabled from "@/app/common/views/Disabled.vue";
import NotFoundPage from "@/app/common/views/NotFoundPage.vue";
import Help from "@/app/common/views/Help.vue";
import FeverPrivacy from "@/app/common/views/FeverPrivacy.vue";
import SubscriptionVerify from "@/app/common/views/SubscriptionVerify.vue";
import FeverDownload from "@/app/common/views/FeverDownload.vue";
import DesignSystem from "@/app/common/views/DesignSystem.vue";
import CittadinoMain from "@/app/layout/views/CittadinoMain.vue";
import OperatoreMain from "@/app/layout/views/OperatoreMain.vue";
import AdminMain from "@/app/layout/views/AdminMain.vue";
import Reporting from "@/app/modules/admin/views/Reporting.vue"
import AccessoSpid from "@/app/common/components/AccessoSpid.vue";
import AccessoCie from "@/app/common/components/AccessoCie.vue";
import { usePageFocus } from "@/app/common/composables/usePageFocus";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    // component: () => import('@/views/Home.vue'),
  },
  { path: "/login", name: "LoginPage", component: LoginPage },
  { path: "/login/spid", name: "AccessoSpid", component: AccessoSpid },
  { path: "/login/cie", name: "AccessoCie", component: AccessoCie },
  { path: "/register", name: "RegisterPage", component: RegisterPage },
  { path: "/disabled", name: "Disabled", component: Disabled },
  { path: "/design-system", name: "DesignSystem", component: DesignSystem },
  {
    path: "/password/reset",
    name: "RecoverPassword",
    component: RecoverPassword,
  },
  {
    path: "/help",
    name: "help",
    component: Help,
  },
  {
    path: "/fever/privacy",
    name: "FeverPrivacy",
    component: FeverPrivacy,
  },
  {
    path: "/subscription/verify/:hashid",
    name: "SubscriptionVerify",
    component: SubscriptionVerify,
  },
  {
    path: "/fever/download",
    name: "FeverDownload",
    component: FeverDownload,
  },
  {
    path: "/password/recovery",
    name: "recupero password",
    component: PasswordRecovery,
  },
  {
    path: "/email/verify/:status",
    name: "EmailVerification",
    component: EmailVerification,
  },
  {
    path: "/number/verify",
    name: "NumberVerification",
    component: NumberVerification,
  },
  {
    path: "/payment/:purchase/:outcome?",
    name: "PaymentOutcome",
    component: () => import("@/app/common/views/PaymentOutcome.vue"),
  },
  {
    path: "/cittadino",
    component: CittadinoMain,
    children: [
      {
        path: "home",
        name: "CittadinoHome",
        component: () =>
          import("@/app/modules/homepage/views/CittadinoHome.vue"),
      },
      {
        path: "familiari/:section/:hash?",
        name: "familiari",
        component: () =>
          import("@/app/modules/familiari/views/FamiliariMain.vue"),
      },
      {
        path: "appuntamenti/:section/:type",
        name: "appuntamenti",
        component: () =>
          import(
            "@/app/modules/servizi/prenotazioni/views/PrenotazioniCittadinoMain.vue"
          ),
      },
      {
        path: "agenda",
        name: "agenda",
        component: () =>
          import(
            "@/app/modules/servizi/prenotazioni/views/CittadinoAgenda.vue"
          ),
      },
      {
        path: "teleconsulti/:section/:subsection?/:type?",
        name: "teleconsulti",
        component: () =>
          import(
            "@/app/modules/servizi/teleconsulto/views/TeleconsultoCittadinoMain.vue"
          ),
      },
      // {
      //   path: "teleconsulto",
      //   name: "il tuo consulto",
      //   component: () =>
      //     import(
      //       "@/app/modules/servizi/teleconsulto/views/PreviewConsultoCittadino.vue"
      //     ),
      // },
      {
        path: "circolocura",
        name: "circolo di cura",
        component: () =>
          import("@/app/modules/circoloDiCura/views/CircoloCura.vue"),
      },
      {
        path: "sottoscrizioni/:section/:action?",
        name: "sottoscrizioni paziente",
        component: () =>
          import(
            "@/app/modules/sottoscrizioni/views/SottoscrizioniCittadinoMain.vue"
          ),
      },
      {
        path: "progetti/:hashprogetto/:section/:subsection?",
        name: "progetti cittadino",
        component: () =>
          import("@/app/modules/servizi/blog/views/ProgettiMain.vue"),
      },
      {
        path: "profilosanitario/:section/:action?",
        name: "profilo sanitario",
        component: () =>
          import(
            "@/app/modules/servizi/profiloSanitario/views/ProfiloSanitarioMain.vue"
          ),
      },
      {
        path: "impostazioni",
        name: "ImpostazioniCittadinoMain",
        component: () =>
          import(
            "@/app/modules/impostazioni/views/ImpostazioniCittadinoMain.vue"
          ),
      },
      { path: "profilo", name: "profilo cittadino", component: Profilo },
      {
        path: "segnalazione",
        name: "segnalazione cittadino",
        component: () =>
          import(
            "@/app/modules/servizi/segnalazioni/views/InviaSegnalazioneCittadino.vue"
          ),
      },
      {
        path: "/guidacittadino",
        name: "guida cittadino",
        component: () => import("@/app/common/components/GuidaCittadino.vue"),
      },
      {
        path: "questionario/compila/:quest?",
        name: "completa questionario",
        component: () =>
          import(
            "@/app/modules/servizi/screening/views/CompilaQuestionarioCittadino.vue"
          ),
      },
      {
        path: "questionario/score/compila/:quest?",
        name: "score questionario",
        component: () =>
          import(
            "@/app/modules/servizi/screening/views/FillScoreSurveyCittadino.vue"
          ),
      },
      {
        path: "sessione/compila/:quest?",
        name: "compila sessione cittadino",
        component: () =>
          import(
            "@/app/modules/servizi/screening/components/sections/CompilazioneSessione.vue"
          ),
      },
      {
        path: "familiare/assistito/terapia",
        name: "nuova terapia assistito",
        component: () =>
          import("@/app/modules/familiari/views/NuovaTerapiaAssistito.vue"),
      },
      {
        path: "profilosanitario/pt/:hash",
        name: "il tuo piano terapeutico",
        component: () =>
          import(
            "@/app/modules/servizi/pianiTerapeutici/views/PianoTerapeuticoCittadino.vue"
          ),
      },
    ],
  },
  {
    path: "/operatore",
    component: OperatoreMain,
    children: [
      {
        path: "home",
        name: "CompanyHome",
        component: () => import("@/app/modules/homepage/views/CompanyHome.vue"),
      },
      {
        path: "analitiche",
        name: "analitiche",
        component: () =>
          import("@/app/modules/statistiche/views/StatisticheCompanyMain.vue"),
      },
      {
        path: "agenda",
        name: "agenda appuntamenti",
        component: () =>
          import("@/app/modules/servizi/prenotazioni/views/CompanyAgenda.vue"),
      },
      {
        path: "pazienti",
        name: "pazienti",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/PazientiOperatoreMain.vue"
          ),
      },
      { path: "profilo", name: "profilo operatore", component: Profilo },
      {
        path: "/guidaoperatore",
        name: "guida",
        component: () => import("@/app/common/components/GuidaOperatore.vue"),
      },
      {
        path: "ricerca/:section?",
        name: "ricerca prestazioni",
        component: () =>
          import(
            "@/app/modules/ricercaPrestazioni/views/RicercaPrestazioniMain.vue"
          )
      },
      {
        path: "centriErogatori/:section?/:hashid?",
        name: "centri erogatori",
        component: () =>
          import("@/app/modules/centriErogatori/views/CentriErogatoriMain.vue"),
      },
      {
        path: "teleconsulto/:section",
        name: "teleconsulto",
        component: () =>
          import(
            "@/app/modules/servizi/teleconsulto/views/TeleconsultoOperatoreMain.vue"
          ),
      },
      {
        path: "sessioni/:action?/:quest?",
        name: "sessioni operatore",
        component: () => import("@/app/modules/servizi/screening/views/SessioniMain.vue"),
      },
      {
        path: "attivita/:section/:action?/:quest?",
        name: "attivita",
        component: () =>
          import("@/app/modules/servizi/screening/views/AttivitaMain.vue"),
      },
      {
        path: "conferma-annullamento",
        name: "conferma annullamento",
        component: () =>
          import(
            "@/app/modules/servizi/prenotazioni/views/ConfermaAnnullamento.vue"
          ),
      },
      {
        path: "prenotazioni/:section",
        name: "prenotazioni",
        component: () =>
          import(
            "@/app/modules/servizi/prenotazioni/views/PrenotazioniOperatoreMain.vue"
          ),
      },
      {
        path: "appuntamenti/:section",
        name: "appuntamentiASL",
        component: () =>
          import(
            "@/app/modules/servizi/appuntamenti/views/AppuntamentiMain.vue"
          ),
      },
      {
        path: "progetti/:hashprogetto/:section/:subsection?",
        name: "progetti operatore",
        component: () =>
          import("@/app/modules/servizi/blog/views/ProgettiMain.vue"),
      },
      {
        path: "impostazioni/:section",
        name: "impostazioniOperatore",
        component: () =>
          import(
            "@/app/modules/impostazioni/views/ImpostazioniCompanyMain.vue"
          ),
      },
      {
        path: "bancadati",
        name: "bancadati",
        component: () => import("@/app/modules/libreria/views/BancaDati.vue"),
      },
      {
        path: "archivio",
        name: "archivio",
        component: () => import("@/app/modules/archives/views/CompanyArchiveMain.vue"),
      },
      {
        path: "fatturazione",
        name: "fatturazione",
        meta: { accessKey: "nav.impostazioni" },
        component: () => import("@/app/modules/fatturazione/views/BillingSettings.vue"),
      },
      {
        path: "fatturazione/impostazioni",
        name: "impostazioni fatturazione",
        component: () => import("@/app/modules/fatturazione/views/BillingSettings.vue"),
      },
      {
        path: "pazienti/scheda/:hash",
        name: "scheda paziente",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/SchedaPaziente.vue"
          ),
      },
      {
        path: "pazienti/scheda/:hash/familiari-assistiti-sperimentazione",
        name: "scheda paziente assistito sperimentazione",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/FamiliariAssistitiSperimentazione.vue"
          ),
      },
      {
        path: "sperimentazioni/segnalazioni",
        name: "segnalazioni sperimentazione",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/SegnalazioniSperimentazionePage.vue"
          ),
      },
      {
        path: "pazienti/scheda/:hash/familiari-assistiti",
        name: "scheda paziente assistito",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/FamiliariAssistiti.vue"
          ),
      },
      {
        path: "pazienti/scheda/:hash/familiari/:hashFamiliare",
        name: "scheda familiare",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/SchedaFamiliare.vue"
          ),
      },
      {
        path: "pazienti/scheda/:hash/familiari-assistiti/:hashBambino",
        name: "scheda paziente bambino fever",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/SchedaFamiliareSperimentazione.vue"
          ),
      },
      {
        path: "pazienti/scheda/:hash/nuovo-assistito",
        name: "nuovo bambino fever",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/NuovoBambinoSperimentazione.vue"
          ),
      },
      {
        path: "pazienti/profilo/:hash",
        name: "profilo paziente",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/ProfiloAnagraficoPaziente.vue"
          ),
      },
      {
        path: "pazienti/terapia",
        name: "nuova terapia Paziente",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/NuovaTerapiaPaziente.vue"
          ),
      },
      {
        path: "pazienti/:hash/prenotazioni/nuovo/:tipo",
        name: "nuova prenotazione paziente",
        component: () =>
          import(
            "@/app/modules/servizi/prenotazioni/views/NuovaPrenotazionePaziente.vue"
          ),
      },
      {
        path: "pazienti/servizi/:hash",
        name: "prenota servizio",
        component: () =>
          import(
            "@/app/modules/servizi/prenotazioni/views/OldNuovaPrenotazionePaziente.vue"
          ),
      },
      {
        path: "pazienti/ordine/:hash",
        name: "prenota ordine",
        component: () =>
          import(
            "@/app/modules/servizi/prenotazioni/views/NuovoOrdinePaziente.vue"
          ),
      },
      {
        path: "pazienti/alerts/:hash",
        name: "nuova notifica paziente",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/NuovoAlertPaziente.vue"
          ),
      },
      {
        path: "pazienti/alerts/edit/:hash",
        name: "modifica piano notifiche",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/ModificaAlertPaziente.vue"
          ),
      },
      {
        path: "pazienti/recall/edit/:hash",
        name: "modifica piano recall",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/ModificaAlertPrestazionePaziente.vue"
          ),
      },
      {
        path: "pazienti/alerts/copy/:hash",
        name: "replica piano notifiche",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/ReplicaAlertPaziente.vue"
          ),
      },
      {
        path: "pazienti/referti/dimissioni",
        name: "dimissioni paziente",
        component: () =>
          import(
            "@/app/modules/servizi/gestionePazienti/views/RefertoDimissioni.vue"
          ),
      },
      {
        path: "pazienti/pt/scheda/:hash",
        name: "dettaglio piano terapeutico",
        component: () =>
          import(
            "@/app/modules/servizi/pianiTerapeutici/views/PianoTerapeuticoDetailOperatore.vue"
          ),
      },
      {
        path: "controlroom/:section?/:hash?",
        name: "control room",
        component: () =>
          import(
            "@/app/modules/servizi/monitoraggio/views/MonitoraggioMain.vue"
          ),
      },
      {
        path: "checklist-templates",
        name: "gestione checklist templates",
        component: () =>
          import(
            "@/app/modules/servizi/checklist/views/ChecklistTemplatesControlRoom.vue"
          ),
      },
      // {
      //   path: "emergenze",
      //   name: "emergenze",
      //   component: () =>
      //     import(
      //       "@/app/modules/servizi/teleconsultoEmergenza/views/EmergenzeOperatoreMain.vue"
      //     ),
      // },
      {
        path: "pt",
        name: "piani terapeutici",
        component: () =>
          import(
            "@/app/modules/servizi/pianiTerapeutici/views/PianiTerapeuticiOperatoreMain.vue"
          ),
      },
      {
        path: "pt/scheda/:hash",
        name: "piano terapeutico",
        component: () =>
          import(
            "@/app/modules/servizi/pianiTerapeutici/views/PianoTerapeuticoDetailOperatoreAsl.vue"
          ),
      },
      {
        path: "chat-pazienti",
        name: "chat pazienti whitelist",
        component: () =>
          import(
            "@/app/modules/servizi/chatPazienti/ChatPazientiWhitelist.vue"
          ),
      },
    ],
  },
  {
    path: "/admin",
    component: AdminMain,
    children: [
      {
        path: "home",
        name: "AdminDashboard",
        component: () => import("@/app/modules/admin/views/AdminDashboard.vue"),
      },
      {
        path: "utenti",
        name: "gestione utenti",
        component: () => import("@/app/modules/admin/views/GestioneUtenti.vue"),
      },
      {
        path: "prenotazioni",
        name: "gestione prenotazioni",
        component: () =>
          import("@/app/modules/admin/views/GestionePrenotazioni.vue"),
      },
      {
        path: "aziende/nuova",
        name: "nuova azienda",
        component: () => import("@/app/modules/admin/views/NuovaCompany.vue"),
      },
      {
        path: "aziende/dettaglio/:company",
        name: "dettaglio azienda",
        component: () =>
          import("@/app/modules/admin/views/DettaglioAzienda.vue"),
      },
      {
        path: "aziende/:section?",
        name: "gestione aziende",
        component: () =>
          import("@/app/modules/admin/views/GestioneAziendeMain.vue"),
      },
      {
        path: "sessioni",
        name: "gestione sessioni",
        component: () =>
          import("@/app/modules/admin/views/AdminSurveySessions.vue"),
      },
      {
        path: "servizi",
        name: "gestione servizi",
        component: () =>
          import("@/app/modules/admin/views/AdminHomeServices.vue"),
      },

      {
        path: "prenotazioni",
        name: "servizio facile",
        component: () =>
          import("@/app/modules/admin/views/GestioneServizioPrenotazioni.vue"),
      },
      {
        path: "teleconsulto",
        name: "servizio di teleconsulto",
        component: () =>
          import("@/app/modules/admin/views/GestioneTeleconsulto.vue"),
      },
      {
        path: "screening/:section/:action?/:quest?",
        name: "screening",
        component: () =>
          import(
            "@/app/modules/servizi/screening/views/ScreeningAdminMain.vue"
          ),
      },
      {
        path: "alerts",
        name: "admin alerts",
        component: () => import("@/app/modules/admin/views/AdminAlerts.vue"),
      },
      {
        path: "syslog",
        name: "log di sistema",
        component: () => import("@/app/modules/admin/views/LogSistema.vue"),
      },
      {
        path: "contatti",
        name: "contattipubblici",
        component: () =>
          import("@/app/modules/admin/views/AdminContattiPubblici.vue"),
      },
      {
        path: "settingsys/nuovo",
        name: "impostazioni sistema",
        component: () =>
          import("@/app/modules/admin/views/ImpostazioniSistema.vue"),
      },
      {
        path: "registrazioni",
        name: "registrazioniAdmin",
        component: () =>
          import("@/app/modules/admin/views/AdminRegistrazioni.vue"),
      },
      {
        path: "sottoscrizioni/:section",
        name: "admin sottoscrizioni",
        component: () =>
          import("@/app/modules/admin/views/MainSottoscrizioniAdmin.vue"),
      },
      {
        path: "piani",
        name: "piani asl",
        component: () =>
          import(
            "@/app/modules/servizi/pianiTerapeutici/views/PianiTerapeuticiAdminMain.vue"
          ),
      },
      {
        path: "piani/scheda/:hash",
        name: "dettaglio pt asl",
        component: () =>
          import(
            "@/app/modules/servizi/pianiTerapeutici/views/PianoTerapeuticoDetailAdmin.vue"
          ),
      },
      {
        path: "reports",
        name: "reports metabase",
        component: Reporting
      },
      {
        path: "pagamenti",
        name: "pagamenti piattaforma",
        component: () =>
          import("@/app/modules/admin/views/PagamentiPiattaforma.vue"),
      },
    ],
  },
  {
    path: "/*",
    name: "pagina non trovata",
    component: NotFoundPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // Pagine accessibili senza autenticazione - se loggato, redirect a home
  const publicPagesRedirectIfLogged = [
    "/login",
    "/register",
    "/password/reset",
    "/password/recovery",
    "/disabled",
    "/login/spid",
    "/login/cie",
  ];

  // Pagine accessibili sempre (con o senza login, nessun redirect).
  // /help è la guida a cui porta l'etichetta nella finestra «Informazioni» del
  // piè di pagina, che c'è anche sulla pagina di accesso: senza login il clic
  // rimandava al login stesso e sembrava non fare niente
  const publicPagesNoRedirect = [
    "/help",
    "/fever/privacy",
    "/fever/download",
    "/email/verify/already",
    "/email/verify/success",
  ];

  const publicPages = [...publicPagesRedirectIfLogged, ...publicPagesNoRedirect];

  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  // Eccezioni: sempre accessibili senza redirect
  if (to.name === "PaymentOutcome" || to.name === "RecoverPassword" || to.name === "SubscriptionVerify") {
    return next();
  }

  // Non loggato su pagina protetta: redirect al login
  if (authRequired && !loggedIn) {
    return next("/login");
  }

  // Loggato su pagina pubblica con redirect: vai a home
  if (!authRequired && loggedIn && publicPagesRedirectIfLogged.includes(to.path)) {
    return next("/");
  }

  next();
});
router.afterEach(() => {
  window.scrollTo(0, 0);
  usePageFocus().focusMainContent();
});

export default router;
